import { render, staticRenderFns } from "./month.vue?vue&type=template&id=b2f1d77c&scoped=true"
import script from "./month.vue?vue&type=script&lang=js"
export * from "./month.vue?vue&type=script&lang=js"
import style0 from "./month.vue?vue&type=style&index=0&id=b2f1d77c&prod&lang=css"
import style1 from "./month.vue?vue&type=style&index=1&id=b2f1d77c&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f1d77c",
  null
  
)

export default component.exports